/*
 * This file is auto-generated. Do not modify it manually!
 */
import React from 'react';

import type { IconSize } from '../types';

interface IconProps extends React.SVGProps<SVGSVGElement> {
    /** If specified, renders an sr-only element for screenreaders */
    alt?: string;
    /** If specified, renders an inline title element */
    title?: string;
    /**
     * The size of the icon
     * Refer to the sizing taxonomy: https://design-system.protontech.ch/?path=/docs/components-icon--basic#sizing
     */
    size?: IconSize;
}

export const IcBrandProton = ({ alt, title, size = 4, className = '', viewBox = '0 0 16 16', ...rest }: IconProps) => {
    return (
        <>
            <svg
                viewBox={viewBox}
                className={`icon-size-${size} ${className}`}
                role="img"
                focusable="false"
                aria-hidden="true"
                {...rest}
            >
                {title ? <title>{title}</title> : null}

                <path
                    fillRule="evenodd"
                    d="M3 1h6.5a4.5 4.5 0 1 1 0 9h-3a.5.5 0 0 0-.5.5V15H3v-5a3 3 0 0 1 3-3h3.5a1.5 1.5 0 0 0 0-3H6v2H3V1Zm1 1v3h1V3h4.5a2.5 2.5 0 0 1 0 5H6a2 2 0 0 0-2 2v4h1v-3.5A1.5 1.5 0 0 1 6.5 9h3a3.5 3.5 0 1 0 0-7H4Z"
                ></path>
            </svg>
            {alt ? <span className="sr-only">{alt}</span> : null}
        </>
    );
};
